module.exports = __webpack_public_path__ + "static/media/20231026-DSC_4705.ac85ab09.jpg";